import { Grid, Paper } from "@mui/material";

const images = [
  "ABF 2024-1.jpg",
  "ABF 2024-4.jpg",
  "ABF 2024-27.jpg",
  "ABF 2024-28.jpg",
  "ABF 2024-87.jpg",
  "ABF 2024-91.jpg",
  "ABF 2024-119.jpg",
  "ABF 2024-7.jpg",
];

const GalleryAbf = () => {
  return (
    <Grid container spacing={1} justifyContent="center">
      {images.map((image, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Paper elevation={3}>
            <img
              src={image}
              alt={`photo-${index}`}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default GalleryAbf;
